import React from 'react';
import { Navigate } from "react-router-dom";
import Cookies from 'universal-cookie';

function NotFound() {
  // Create a cookies instance
  const cookies = new Cookies();

  // Function to get the session token from the cookie
  const getSessionCookie = () => {
    return cookies.get('sessionToken');
  };

  // Get the session token
  const sessionToken = getSessionCookie();

  return (
    (!sessionToken || sessionToken.length <= 20) ? (
      <Navigate to="/login" />
    ) : (
    <Navigate to="/" />
    )
  );
}

export default NotFound;
